module.exports = "/_next/static/resources/photo-2-bcdb40f1b678c053f7257a15e33e02d0.jpg";